import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getStudentById = async id => {
  const res = await api.get(`/ClassDiaryV1/student/${id}/profile`);
  return res.data;
};

const getClasses = async (id, codPerlet) => {
  const res = await api.get(`/ClassDiaryV1/student/${id}/classes`, {
    params: codPerlet ? { codPerlet } : {}
  });
  return Array.isArray(res.data) ? res.data : [];
};

/** Diretório global (menu Alunos / WBSCR-780 / WBSCR-783 / WBSCR-784). */
const getStudents = async ({ search = "", classId = "", limit, skip } = {}) => {
  const res = await api.get(`/ClassDiaryV1/students`, {
    params: {
      ...(search ? { search } : {}),
      ...(classId ? { classId } : {}),
      ...(limit != null ? { limit, skip: skip || 0 } : {})
    }
  });
  return res.data;
};

const getGrades = async studentId => {
  const res = await api.get(
    `Academics/student/${studentId}/report-cards-external`,
    {
      params: { filter: { schoolYear: new Date().getFullYear() } }
    }
  );
  return res.data;
};

const getSchedule = async (start, end, studentId) => {
  const res = await api.get(`/Academics/student/schedule/${studentId}`, {
    params: { start, end }
  });
  return res.data;
};

const getOccurrences = async (
  studentId,
  codPerlet,
  codOccurrenceType = undefined,
  codOccurrenceReason = undefined
) => {
  const res = await api.get(`/ClassDiaryV1/student/${studentId}/occurrences`, {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      codPerlet,
      codOccurrenceType,
      codOccurrenceReason
    }
  });
  return res.data;
};

const getCustomMenus = async studentId => {
  const res = await api.get(`/ClassDiaryV1/student/${studentId}/custom-menus`);
  return (res.data && res.data.menus) || [];
};

const getReports = async (studentId, idTurmaDisc) => {
  const res = await api.get(`/ClassDiaryV1/student/${studentId}/reports`, {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      // idTurmaDisc opcional — params por linha no FE (ra_disc)
      ...(idTurmaDisc ? { idTurmaDisc } : {})
    }
  });
  return res.data;
};

/** Disciplinas do aluno (matrícula) — fallback do select de relatórios ra_disc. */
const getDisciplines = async (studentId, classId) => {
  const res = await api.get(`/ClassDiaryV1/student/${studentId}/discipline`, {
    params: {
      ...(classId ? { classId } : {})
    }
  });
  return res.data;
};

export default {
  getStudentById,
  getClasses,
  getStudents,
  getGrades,
  getSchedule,
  getOccurrences,
  getCustomMenus,
  getReports,
  getDisciplines
};
